<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-left">
            <h2 class="dialog-title">Profile Settings</h2>
        </div>
        <button class="close-btn" (click)="closeDialog()">
            <rds-icon namespace="outlined" icon="close"></rds-icon>
        </button>
    </div>

    <div class="dialog-content">
        <div class="left-section" [class.collapsed]="isLeftSectionCollapsed">
            <div class="section-buttons">
                <!-- Expanded view -->
                <button *ngIf="!isLeftSectionCollapsed" class="characteristic-btn"
                    [class.active]="activeSection === 'profile'" (click)="setActiveSection('profile')">
                    <span class="btn-text">Profile Information</span>
                </button>
                <button *ngIf="!isLeftSectionCollapsed" class="characteristic-btn"
                    [class.active]="activeSection === 'notifications'" (click)="setActiveSection('notifications')">
                    <span class="btn-text">Notifications</span>
                </button>

                <!-- Collapsed view -->
                <button *ngIf="isLeftSectionCollapsed" class="characteristic-letter-btn"
                    [class.active]="activeSection === 'profile'" (click)="setActiveSection('profile')"
                    rdsTooltip="Profile Information">
                    P
                </button>
                <button *ngIf="isLeftSectionCollapsed" class="characteristic-letter-btn"
                    [class.active]="activeSection === 'notifications'" (click)="setActiveSection('notifications')"
                    rdsTooltip="Notifications">
                    N
                </button>

                <button class="collapse-btn" (click)="toggleLeftSection()">
                    <rds-icon namespace="outlined"
                        [icon]="isLeftSectionCollapsed ? 'chevron_double_right' : 'chevron_double_left'"></rds-icon>
                </button>
            </div>
        </div>

        <div class="right-section">
            <!-- Profile Information Section -->
            <div class="form-section" *ngIf="activeSection === 'profile'">

                <div class="form-row">
                    <div class="form-field-wrapper half">
                        <label class="form-label">First Name</label>
                        <div class="input-container">
                            <input type="text" class="form-input" [value]="firstName" disabled />
                        </div>
                    </div>
                    <div class="form-field-wrapper half">
                        <label class="form-label">Last Name</label>
                        <div class="input-container">
                            <input type="text" class="form-input" [value]="lastName" disabled />
                        </div>
                    </div>
                </div>
                <div class="form-field-wrapper">
                    <label class="form-label">Email</label>
                    <div class="input-container">
                        <input type="text" class="form-input" [value]="email" disabled />
                    </div>
                </div>
            </div>

            <!-- General Notifications Section -->
            <div class="form-section" *ngIf="activeSection === 'notifications'">
                <div class="form-field-wrapper">
                    <label class="form-label">Email Notification Preferences</label>
                    <div class="radio-options-vertical">
                        <label class="radio-option" [class.selected]="notificationPreference === 'ALL'">
                            <input type="radio" name="notification" value="ALL"
                                [(ngModel)]="notificationPreference" (ngModelChange)="onNotificationChange()" />
                            <div class="radio-content">
                                <span class="radio-label">All Activities</span>
                                <span class="radio-description">Receive notifications for all comments and team updates on projects <b>you own</b>
                                </span>
                            </div>
                        </label>
                        <label class="radio-option" [class.selected]="notificationPreference === 'MENTIONS_ONLY'">
                            <input type="radio" name="notification" value="MENTIONS_ONLY"
                                [(ngModel)]="notificationPreference" (ngModelChange)="onNotificationChange()" />
                            <div class="radio-content">
                                <span class="radio-label">Mentions Only</span>
                                <span class="radio-description">Receive notifications when you are tagged or mentioned</span>
                            </div>
                        </label>
                        <label class="radio-option" [class.selected]="notificationPreference === 'NO_NOTIFICATIONS'">
                            <input type="radio" name="notification" value="NO_NOTIFICATIONS"
                                [(ngModel)]="notificationPreference" (ngModelChange)="onNotificationChange()" />
                            <div class="radio-content">
                                <span class="radio-label">No email notifications</span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer only for notifications section -->
    <div class="dialog-footer" *ngIf="activeSection === 'notifications'">
        <button class="footer-btn cancel-btn" (click)="cancelNotificationChanges()">
            Cancel
        </button>
        <button class="footer-btn save-btn" (click)="saveNotificationSettings()"
            [disabled]="!hasNotificationChanges || isSaving">
            Save
        </button>
    </div>
</div>
